export default __webpack_public_path__ + "static/media/wnew3.d8f56bf3.png";